import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PriceSummaryDisplayContent } from '../price-summary-display/price-summary-display-content';

@Component({
    selector: 'nwx-price-summary-footer',
    templateUrl: './price-summary-footer.component.html',
    styleUrl: './price-summary-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PriceSummaryFooterComponent {
  @Input() content: PriceSummaryDisplayContent = {};

  @Output() showPdf = new EventEmitter<void>();

  isNumber(str: any): boolean {
    return !isNaN(parseFloat(str)) && str !== '';
  }

  showPackagePremium(): boolean {
    if (
      this.content.products?.some(
        (product) => !!product.errorMessage || product.totalPrice === '$--.--'
      )
    ) {
      return false;
    }
    return true;
  }
}
